import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Modal,
  Panel,
  Row,
  Col,
  Button
} from 'react-bootstrap';
import {
  LoadingSpinner,
  JNInitWizardPageOne,
  JNInitWizardPageTwo,
  JNInitWizardPageThree,
  JNInitWizardPageFour,
  JNInitWizardPageFive,
  JNInitWizardPageSix,
  ConfirmationPrompt
} from 'components';
import {
  fetchJobNimbusAccountSettings,
  initJobNimbusIntegration,
  fetchFields
 } from 'api';
import { notify, updateUser } from 'actions';

let _mounted = false;

class JNInitWizardContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: true,
      submitting: false,
      submit_success: false,
      submit_in_process: false,
      submit_error: false,
      current_wizard_page: 1,
      api_key: '',
      jn_custom_fields: [],
      ht_fields: [],
      formatted_ht_fields: [],
      field_map: {},
      merge_options: {
        direction: null,
        merge_key: null,
        dominant_set: null
      },
      merge_key_chosen: false,
      show_clear_ht_data_warning: false,
      next_valid: false,
      api_key_dirty: false,
      type_default: null,
      status_default: null,
      jn_workflows: []
    }

    this.handleClickBackButton = this.handleClickBackButton.bind(this);
    this.handleClickNextButton = this.handleClickNextButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeMergeDirection = this.handleChangeMergeDirection.bind(this);
    this.handleChangeMergeKey = this.handleChangeMergeKey.bind(this);
    this.handleChangeMergeDomSet = this.handleChangeMergeDomSet.bind(this);
    this.confirmeClearHailTraceData = this.confirmeClearHailTraceData.bind(this);
    this.cancelClearHailTraceData = this.cancelClearHailTraceData.bind(this);
    this.handleFieldMapChange = this.handleFieldMapChange.bind(this);
    this.handleTypeDefaultChange = this.handleTypeDefaultChange.bind(this);
    this.handleStatusDefaultChange = this.handleStatusDefaultChange.bind(this);
  }

  handleClickBackButton() {
    const { current_wizard_page, merge_options } = this.state;
    if(
      merge_options.direction == 'into_ht' &&
      current_wizard_page == 4
    ) {
      this.setState({ current_wizard_page: 2 });
    }
    else {
      this.setState({ current_wizard_page: current_wizard_page - 1 });
    }
  }
  handleClickNextButton() {
    const {
      current_wizard_page,
      next_valid,
      merge_options,
      api_key_dirty
    } = this.state;

    if(next_valid) {
      if(
        merge_options.direction == 'into_ht' &&
        current_wizard_page == 2
      ) {
        this.setState({ current_wizard_page: 6 });
      }
      else {
        if(current_wizard_page == 1) {
          if(api_key_dirty) {
            this.setState({
              fetching: true,
              next_valid: false
             });
            fetchJobNimbusAccountSettings(this.state.api_key)
            .then(res => {
              if(_mounted) {
                if(res.statusCode != 200) {
                  if(res.statusCode == 401) {
                    throw new Error('Invalid credentials. Double check that your API key is correct.');
                  }
                  else {
                    this.props.toggleInitializing();
                    throw new Error('Error connecting to Job Nimbus. Please try again later');
                  }
                }
                const { custom_fields_contact, workflows } = res.body;
                this.setState({
                  jn_custom_fields: custom_fields_contact,
                  current_wizard_page: 2,
                  fetching: false,
                  jn_workflows: workflows
                });
              }
            })
            .catch(e => {
              this.props.notify({ message: e.message || e });
              if(_mounted) {
                this.setState({ fetching: false });
              }
            });
          }
        }
        else {
          this.setState({ current_wizard_page: current_wizard_page + 1 });
        }
      }
    }
  }
  handleSubmit() {
    this.setState({ submitting: true });
    const {
      api_key,
      merge_options,
      field_map,
      type_default,
      status_default
    } = this.state;
    const jn_init_payload = {
      settings: {
        api_key,
        merge_options,
        field_map,
        type_default: type_default ? type_default.label : null,
        status_default: status_default ? status_default.label : null
      }
    };

    initJobNimbusIntegration(jn_init_payload)
      .then((res, err) => {
        const { user } = this.props.users;
        const settings = user.settings ? user.settings : {};
        const updated_jn_settings = {
          api_key: this.state.api_key,
          type_default: this.state.type_default,
          status_default: this.state.status_default
        }
        this.props.updateUser({ settings: { ...settings, jobnimbus: { api_key: this.state.api_key } } });
        if(_mounted) {
          this.setState({
            submitting: false,
            submit_success: true,
            submit_in_process: res.in_process == true
          });
        }
      })
      .catch(e => {
        if(_mounted) {
          this.setState({ submitting: false, submit_error: true });
        }
      });
  }
  handleChangeMergeDirection(dir) {
    if(dir && dir.value == 'into_ht') {
      this.setState({
        merge_options: { direction: dir },
        show_clear_ht_data_warning: true
      });
    }
    else {
      this.setState({
        merge_options: {
          ...this.state.merge_options,
          direction: dir ? dir.value : null
        }
      });
    }
  }
  confirmeClearHailTraceData() {
    this.setState({
      merge_options: { ...this.state.merge_options, direction: 'into_ht' },
      show_clear_ht_data_warning: false
    });
  }
  cancelClearHailTraceData() {
    this.setState({
      merge_options: { ...this.state.merge_options, direction: 'both' },
      show_clear_ht_data_warning: false
    });
  }
  handleFieldMapChange(updated_field_map) {
    this.setState({
      field_map: {
        ...this.state.field_map,
        ...updated_field_map
      }
    });
  }
  handleTypeDefaultChange(select_val) {
    if(this.state.type_default != select_val.value) {
      this.setState({
        type_default: select_val,
        status_default: null
      });
    }
  }
  handleStatusDefaultChange(select_val) {
    this.setState({ status_default: select_val });
  }
  handleChangeMergeKey(key) {
    this.setState({
      merge_options: {
        ...this.state.merge_options,
        merge_key: key ? key.value : null
      }
    });
  }
  handleChangeMergeDomSet(set) {
    this.setState({
      merge_options: {
        ...this.state.merge_options,
        dominant_set: set ? set.value : null
      }
    });
  }
  componentWillMount() {
    fetchFields('client')
    .then(fields => {
      this.setState({
        fetching: false,
        formatted_ht_fields: fields.map(f => ({ value: f.name, label: f.label })),
        ht_fields: fields
      });
    })
    .catch(e => {
      this.setState({ fetching: false })
      this.props.notify({ message: e.message || e })
    });
  }
  componentDidMount() {
    _mounted = true;
  }
  componentDidUpdate(prev_props, prev_state) {
    const {
      current_wizard_page,
      next_valid,
      api_key,
      merge_options,
    } = this.state;

    // Checks if the api key was updated, and if so, flags the component to
    //    fetch the JN account data after setting key
    if(prev_state.api_key != api_key) {
      this.setState({ api_key_dirty: true });
    }

    // Toggles the state of the 'Next' button between enabled and disabled
    if(current_wizard_page == 1) {
      if(api_key != '' && !next_valid) {
        this.setState({ next_valid: true });
      }
      else if(api_key == '' && next_valid) {
        this.setState({ next_valid: false });
      }
    }
    else if(current_wizard_page == 2) {
      const { direction, merge_key } = merge_options;

      if(!direction && next_valid) {
        this.setState({ next_valid: false });
      }
      else if(direction == 'into_ht' && !next_valid) {
        this.setState({ next_valid: true });
      }
      else if(direction == 'both') {
        if(!merge_key && next_valid) {
          this.setState({ next_valid: false });
        }
        else if(merge_key != null && !next_valid) {
          this.setState({ next_valid: true });
        }
      }
    }
    else if(current_wizard_page == 3) {
      const { dominant_set } = merge_options;

      if(!dominant_set && next_valid) {
        this.setState({ next_valid: false });
      }
      else if(dominant_set != null && !next_valid) {
        this.setState({ next_valid: true });
      }
    }
    else if(current_wizard_page == 5) {
      if(
        this.state.type_default == null ||
        this.state.status_default == null
      ) {
        if(this.state.next_valid) {
          this.setState({ next_valid: false });
        }
      }
      else if(!this.state.next_valid) {
        this.setState({ next_valid: true });
      }
    }
  }
  componentWillUnmount() {
    _mounted = false;
  }

  render() {
    const { show, onHide } = this.props;
    const { current_wizard_page, merge_options, field_map } = this.state;
    const static_jn_fields = [
      { field: 'work_phone', title: 'Work Phone', type: 'string' },
      { field: 'mobile_phone', title: 'Mobile Phone', type: 'string' },
      { field: 'fax_number', title: 'Fax Number', type: 'string' }
    ];

    return (
      <Modal
        show={show}
        onHide={onHide}
        backdrop='static'
        >
        <Modal.Header
          bsClass='modal-header success'
          closeButton
          >
          <Modal.Title>Job Nimbus Integration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            if(this.state.fetching) {
              return <LoadingSpinner />
            }
            else if(this.state.submitting) {
              return (
                <div>
                  <Row>
                    <Col xs={12} md={12}>
                      Your Job Nimbus integration is being processed ...
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <LoadingSpinner />
                    </Col>
                  </Row>
                </div>
              )
            }
            else if(this.state.submit_success) {
              return (
                <div>
                  {this.state.submit_in_process ? (
                    <Row>
                      <Col xs={12} md={12}>
                        <center><p>
                          The integration may take a few minutes to complete. An email will be{' '}
                          sent to your account when the process has finished.
                        </p></center>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12} md={12}>
                        <center><h1>Success!</h1></center>
                      </Col>
                      <Col xs={12} md={12}>
                        <center><p>Your Job Nimbus integration has completed successfully</p></center>
                      </Col>
                    </Row>
                  )}
                </div>
              );
            }
            else if(this.state.submit_error) {
              return (
                <div>
                  <Row>
                    <Col md={12} xs={12} style={{ color: 'red' }}>
                      <center><i className='fa fa-exclamation-triangle' /></center>
                    </Col>
                  </Row>
                  <Row>
                    <center><p>
                      There was an error processing your Job Nimbus integration. Your Hail Trace data has been
                      reset, but your Job Nimbus data may have been altered. If so, please contact your Job Nimbus
                      admin, and we will work together to restore your Job Nimbus data.
                    </p></center>
                  </Row>
                </div>
              );
            }
            else {
              return (
                <div key={current_wizard_page}>
                  {(() => {
                    switch(current_wizard_page) {
                      case 1:
                        return (
                          <JNInitWizardPageOne
                            api_key={this.state.api_key}
                            handleApiKeyChange={({ target }) => {this.setState({ api_key: target.value })}}
                            setJobNimbusFields={fields => {this.setState({ jn_custom_fields: fields })}}
                          />
                        );
                        break;
                      case 2:
                        return (
                          <JNInitWizardPageTwo
                            handleChangeDirection={this.handleChangeMergeDirection}
                            handleChangeMergeKey={this.handleChangeMergeKey}
                            merge_options={merge_options}
                            merge_key_chosen={this.state.merge_key_chosen}
                          />
                        );
                        break;
                      case 3:
                        return (
                          <JNInitWizardPageThree
                            handleChangeMergeDomSet={this.handleChangeMergeDomSet}
                            merge_options={merge_options}
                          />
                        );
                        break;
                      case 4:
                        return (
                          <JNInitWizardPageFour
                            field_map={this.state.field_map}
                            handleFieldMapChange={this.handleFieldMapChange}
                            ht_fields={this.state.ht_fields}
                            formatted_ht_fields={this.state.formatted_ht_fields}
                            jn_fields={[ ...this.state.jn_custom_fields, ...static_jn_fields ]}
                          />
                        );
                        break;
                      case 5:
                        return (
                          <JNInitWizardPageFive
                            workflows={this.state.jn_workflows}
                            handleTypeDefaultChange={this.handleTypeDefaultChange}
                            handleStatusDefaultChange={this.handleStatusDefaultChange}
                            type_default={this.state.type_default}
                            status_default={this.state.status_default}
                          />
                        );
                        break;
                      case 6:
                        return (
                          <JNInitWizardPageSix
                            merge_options={merge_options}
                            field_map={field_map}
                            jn_fields={[ ...static_jn_fields, ...this.state.jn_custom_fields ]}
                            type_default={this.state.type_default}
                            status_default={this.state.status_default}
                          />
                        );
                        break;
                    }
                  })()}
                </div>
              )
            }
          })()}

        </Modal.Body>
        <Modal.Footer>
          {(() => {
            if(this.state.submit_success || this.state.submit_error) {
              return (
                <Row>
                  <Col xs={12} md={12}>
                    <Button
                      bsStyle={this.state.submit_success ? 'success' : 'danger'}
                      bsSize='small'
                      block
                      onClick={this.props.toggleInitializing}
                      >
                      Ok
                    </Button>
                  </Col>
                </Row>
              )
            }
            else {
              return (
                <Row>
                  <Col md={6} sm={6}>
                    {current_wizard_page != 1 ? (
                      <Button
                        bsStyle='success'
                        bsSize='small'
                        block
                        disabled={this.state.fetching || this.state.submitting}
                        onClick={this.handleClickBackButton}
                        >
                        <i className='fa fa-arrow-left' /> Previous
                      </Button>
                    ) : null}
                  </Col>
                  <Col md={6} sm={6}>
                    {current_wizard_page != 6 ? (
                      <Button
                        bsStyle='success'
                        bsSize='small'
                        block
                        disabled={!this.state.next_valid || this.state.submitting || this.state.fetching}
                        onClick={this.handleClickNextButton}
                        >
                        Next <i className='fa fa-arrow-right' />
                      </Button>
                    ) : (
                      <Button
                        bsStyle='success'
                        bsSize='small'
                        block
                        onClick={this.handleSubmit}
                        disabled={this.state.submitting || this.state.fetching}
                        >
                        Submit
                      </Button>
                    )}
                  </Col>
                </Row>
              )
            }
          })()}
        </Modal.Footer>

        <ConfirmationPrompt
          show_condition={this.state.show_clear_ht_data_warning}
          handleCancelPrompt={this.cancelClearHailTraceData}
          handleConfirmPrompt={this.confirmeClearHailTraceData}
          type='danger'
          title='!'
          body={`Are you sure you want to clear your Hail Trace client data and replace it
            with your Job Nimbus contact data? This cannot be undone.`}
          confirm_button_text='Confirm'
          cancel_button_text='Cancel'
          bsSize='small'
        />
      </Modal>
    );
  }
}
const mapStateToProps = ({ users }) => ({ users });

export default connect(mapStateToProps, { notify, updateUser })(JNInitWizardContainer);



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-container.js